<div class="user-managment-page-container">
    <form
        (submit)="f.form.valid && processCreateData()"
        #f="ngForm"
        novalidate
    >
        <!-- CHECKBOX USER TYPE -->
        <div class="user-type">
            <div class="type-admin">
                <mat-radio-group required
                    name="user-type"
                    [(ngModel)]="user.userType" >
                    <mat-radio-button [value]="1" [checked]="user.userType">Admin</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="type-user">
                <mat-radio-group required
                    name="user-type"
                    [(ngModel)]="user.userType"
                >
                    <mat-radio-button [value]="2" [checked]="user.userType">User</mat-radio-button>
                </mat-radio-group>
            </div>


        </div>
        <div class="add-user-info">
            <div class="row">
                <!-- NAME -->
                <div class="col-md-6">
                    <div class="form-group padding-right-10">
                        <mat-form-field>
                            <input
                                placeholder="Name"
                                matInput
                                [(ngModel)]="user.name"
                                name="name"
                                #name="ngModel"
                                required
                                (keypress)="keyPressAlpha($event)"
                            >
                            <mat-error *ngIf="name.touched && name.invalid">Name is not valid</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <!-- EMPLOYEE ID -->
                <div class="col-md-6">
                    <div class="form-group">
                        <mat-form-field>
                            <input
                                placeholder="Employee ID"
                                matInput
                                [(ngModel)]="user.userId"
                                name="employeeID"
                                #employeeID="ngModel"
                                required
                                [disabled]="!!user.id"
                            >
                            <mat-error *ngIf="employeeID.touched && employeeID.invalid">Employee ID is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- MOBILE NUMBER -->
                <div class="col-md-6">
                    <div class="form-group padding-right-10">
                        <mat-form-field>
                            <input
                                type="text"
                                placeholder="Mobile Number"
                                matInput
                                [(ngModel)]="user.mobile"
                                name="mobileno"
                                #mobileno="ngModel"
                                required
                                minlength=10
                                maxlength=10
                                (keypress)="keyPress($event)"
                            >
                            <mat-error *ngIf="mobileno.touched && mobileno.invalid">Please enter valid Mobile Number</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <!-- EMAIL -->
                <div class="col-md-6">
                    <div class="form-group">
                        <mat-form-field>
                            <input
                                type="email"
                                placeholder="Email"
                                matInput
                                [(ngModel)]="user.email"
                                name="email"
                                #email="ngModel"
                                required
                                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" 
                            >
                            <mat-error *ngIf="email.touched && email.invalid">Please enter valid Email ID</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row margin-bottom-15">
                <!-- CREATE PASSWORD -->
                <div class="col-md-6">
                    <div class="form-group padding-right-10">
                        <mat-form-field>
                            <input
                                passwordValidator
                                placeholder="Create Password"
                                matInput
                                [type]="hide ? 'password' : 'text'"
                                [(ngModel)]="user.password"
                                name="password"
                                #password="ngModel"
                                maxlength="16"
                                minlength="8"
                                required
                            >
                            <button
                                mat-icon-button
                                matSuffix
                                (click)="hide = !hide"
                                [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hide"
                                type="button"
                            >
                                <mat-icon>
                                    {{
                  hide ? 'visibility_off' : 'visibility'
                }}
                                </mat-icon>
                            </button>
                            <mat-error *ngIf="password.touched && password.invalid" class="create-pswd">Your Password must have atleast 1 alphabet (uppper and lower) ,number,special character.
                                Length of password is between 8 to 16 characters</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <!-- SELECT REGION -->
                <div class="col-md-6">
                    <div class="form-group">
                        <mat-form-field>
                            <mat-select
                                disableOptionCentering
                                placeholder="Select Region"
                                [(ngModel)]="user.region"
                                name="region"
                                #region="ngModel"
                                
                            >
                                <mat-option
                                    *ngFor="let region of regionList"
                                    [value]="region.id"
                                >
                                    {{ region?.regionName }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- SELECT ROLE -->
                <div class="col-md-6">
                    <div class="form-group padding-right-10">
                        <mat-form-field>
                            <mat-select
                                disableOptionCentering
                                placeholder="Select Role"
                                [(ngModel)]="user.role"
                                name="role"
                                #role="ngModel"
                                required
                            >
                                <mat-option
                                    *ngFor="let role of roleList"
                                    [value]="role.id"
                                >
                                    {{ role?.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <!-- SELECT DEPARTMENT -->
                <div class="col-md-6">
                    <div class="form-group">
                        <mat-form-field>
                            <mat-select
                                disableOptionCentering
                                placeholder="Select Department"
                                [(ngModel)]="user.department"
                                name="department"
                                #department="ngModel"
                                
                            >
                                <mat-option
                                    *ngFor="let department of departmentList"
                                    [value]="department.id"
                                >
                                    {{ department?.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="margin-top-20 text-center">
                <button
                    mat-raised-button
                    color="primary"
                    class="mat-button-large"
                    type="submit"
                    [disabled]="!f.valid"
                >
                <span *ngIf="!user?.id">Add User</span>
                <span *ngIf="user?.id">Update User</span>
                </button>
            </div>
        </div>
    </form>
</div>
<div class="user-managment-list-container">
    <app-user-list (editChange)="onEdit($event)" [userList]="userList"></app-user-list>
</div>
